/**
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * Licensed under the BSD 3-Clause license.
 * For full license text, see LICENSE.txt file in the repo root or
 * https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

/**
 * Status Icons
 *
 * Partial Severity icons have an "overhang"
 * Meaning they sized by the primary checkbox section of the icon and the partial section overflows outside of the box.
 * This is done by sizing the container normally, but the SVG is slightly larger and aboslutely positioned inside of the container.
 * The scaling is done by using the relative size of a normal icon's viewbox v a partial icon's viewbox.
 * If a partial icon scale the icon by 1+ (22 - 16) / 22 = 1.375 (Normal icons have a 16x16 viewbox but partial icons have a 22x22 viewbox)
 */

const size = (p) => {
  return p.severity.indexOf('healthy-') === 0
    ? `calc(1.375 * ${p.size ? p.size : '1rem'})`
    : p.size ? p.size : '1rem';
};

const Icon = styled.span`
  display: inline-block;
  vertical-align: middle;
  line-height: 1;
  height: ${(p) => p.size ? p.size : '1rem'};
  width: ${(p) => p.size ? p.size : '1rem'};
`;

const SVG = styled.svg`
  height: ${size};
  width: ${size};
`;

/**
 * Icon Container for Standard SLDS Icons
 */
const StatusIcon = ({ className, onClick, size, severity }) => (
  <Icon size={size} className={className} severity={severity} onClick={onClick} >
    <SVG size={size} severity={severity}>
      <use xlinkHref={`/assets/icons/status-icons2.svg#${severity}`}></use>
    </SVG>
  </Icon>
);

StatusIcon.propTypes = {
  className: PropTypes.string,
  onClick: PropTypes.func,
  href: PropTypes.string,
  severity: PropTypes.string,
  size: PropTypes.string,
};

StatusIcon.defaultProps = {
  show: true,
};

export default StatusIcon;
